import { render, staticRenderFns } from "./CompensationEditor.vue?vue&type=template&id=b10ea5dc"
import script from "./CompensationEditor.vue?vue&type=script&lang=js"
export * from "./CompensationEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports